import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, FileText } from 'lucide-react';
import { Loan } from '../data/mockLoans';
interface NoteModalProps {
  isOpen: boolean;
  loan: Loan | null;
  onClose: () => void;
  onSubmit: (note: string) => void;
}
export function NoteModal({
  isOpen,
  loan,
  onClose,
  onSubmit
}: NoteModalProps) {
  const [note, setNote] = useState('');
  useEffect(() => {
    if (isOpen) {
      setNote('');
    }
  }, [isOpen]);
  if (!isOpen || !loan) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (note.trim()) {
      onSubmit(note);
    }
  };
  return <AnimatePresence data-id="element-106">
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
      backgroundColor: 'rgba(42, 42, 42, 0.5)',
      backdropFilter: 'blur(4px)'
    }} data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden border border-stone-200" data-id="element-108">
          <div className="flex items-center justify-between px-6 py-4 border-b border-stone-100 bg-stone-50/50" data-id="element-109">
            <h2 className="text-lg font-semibold text-stone-900 flex items-center gap-2" data-id="element-110">
              <FileText className="w-5 h-5 text-stone-600" data-id="element-111" />
              Leave Note: {loan.borrowerName}
            </h2>
            <button onClick={onClose} className="p-2 text-stone-400 hover:text-stone-600 hover:bg-stone-100 rounded-full transition-colors" data-id="element-112">
              <X className="w-5 h-5" data-id="element-113" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-6" data-id="element-114">
            <div data-id="element-115">
              <label className="block text-sm font-medium text-stone-700 mb-2" data-id="element-116">
                Note Details <span className="text-rose-500" data-id="element-117">*</span>
              </label>
              <textarea value={note} onChange={e => setNote(e.target.value)} placeholder="Enter your note here..." autoFocus className="w-full h-40 px-4 py-3 rounded-xl border border-stone-200 outline-none transition-all resize-none text-stone-700" onFocus={e => {
              e.currentTarget.style.borderColor = '#C5A55A';
              e.currentTarget.style.boxShadow = '0 0 0 3px rgba(197, 165, 90, 0.15)';
            }} onBlur={e => {
              e.currentTarget.style.borderColor = '#d6d3d1';
              e.currentTarget.style.boxShadow = 'none';
            }} data-id="element-118" />
            </div>

            <div className="pt-2 flex gap-3 border-t border-stone-100" data-id="element-119">
              <button type="button" onClick={onClose} className="flex-1 py-2.5 px-4 rounded-xl border border-stone-200 text-stone-700 font-medium hover:bg-stone-50 transition-colors" data-id="element-120">
                Cancel
              </button>
              <button type="submit" disabled={!note.trim()} className="flex-1 py-2.5 px-4 rounded-xl text-white font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
              backgroundColor: '#2A2A2A'
            }} onMouseEnter={e => {
              if (note.trim()) e.currentTarget.style.backgroundColor = '#1E1E1E';
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#2A2A2A';
            }} data-id="element-121">
                Save Note & Next
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </AnimatePresence>;
}